import {
  configureStore,
  createAction,
  combineReducers,
} from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage for web
import postsReducer from "./postsSlice";
import userReducer from "./userSlice";
import sportsReducer from "./sportsSlice";

// 1. Create logout action
export const logout = createAction("user/logout");

// 2. Persist configuration
const persistConfig = {
  key: "root", // Key for the persisted state in storage
  storage, // Use localStorage for web
  whitelist: ["user"], // Only persist the user slice
  // blacklist: ['posts', 'sports'], // Optionally blacklist slices you don't want to persist
};

// 3. Combine your slice reducers
const appReducer = combineReducers({
  posts: postsReducer,
  user: userReducer,
  sports: sportsReducer,
});

// 4. Root reducer to reset state on logout
const rootReducer = (state, action) => {
  if (action.type === logout.type) {
    // Clear persisted storage on logout
    storage.removeItem("persist:root");
    state = undefined; // Reset entire redux state
  }
  return appReducer(state, action);
};

// 5. Wrap rootReducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 6. Configure store with persistedReducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions to avoid serialization warnings
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/PURGE",
        ],
      },
    }),
});

// 7. Create persistor object
export const persistor = persistStore(store);

// Types for usage elsewhere
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
